import React, {useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import BarChartIcon from '@material-ui/icons/BarChart';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import StarIcon from '@material-ui/icons/Star';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import DashboardIcon from '@material-ui/icons/Dashboard';
import List from '@material-ui/core/List';
import {withRouter} from 'react-router';
import {Divider} from '@material-ui/core';
import {useLocation} from 'react-router-dom';
import {AuthContext} from '../../../context/auth';
import {getPlanStage} from '../../../utils/productAccess';

const ORANGE = '#FF6900';
const GREY = '#A5A5A5';

const useStyles = makeStyles(() => ({
    item: {
        width: '92%',
        margin: '2px 10px',
        borderRadius: '10px',
        padding: '10px 12px',
        color: GREY,
        '&:hover': {backgroundColor: 'rgba(237,102,40,0.08)'},
    },
    itemCollapsed: {
        width: '65%',
    },
    itemActive: {
        backgroundColor: ORANGE,
        color: '#ffffff',
        '&:hover': {backgroundColor: ORANGE},
    },
    backItem: {
        backgroundColor: '#000000 !important',
        '& .MuiTypography-root': {color: '#ffffff'},
        '&:hover': {backgroundColor: '#222222 !important'},
    },
    icon: {minWidth: 'unset', marginRight: '12px'},
    label: {
        '& .MuiTypography-root': {fontSize: '14px', fontWeight: 600},
    },
    divider: {margin: '4px 10px'},
}));

const ClassDashboardList = ({history, isDrawerOpen}) => {
    const classes = useStyles();
    const location = useLocation();
    const {authUser} = useContext(AuthContext);
    // Learning Deployment only makes sense once programs exist — P0 is the
    // baseline-only stage, before any are created — so it's hidden there,
    // same as Partner Dashboard gates its own Program Deployment nav item.
    const stage = getPlanStage(authUser);
    const showLearningDeployment = stage !== 'P0';

    const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

    const NavItem = ({label, icon: Icon, path, isBack}) => {
        const active = !isBack && isActive(path);
        const targetPath = isBack ? path : `${path}${location.search}`;
        return (
            <>
                <ListItem
                    button
                    onClick={() => history.push(targetPath)}
                    className={`${classes.item} ${isBack ? classes.backItem : ''} ${!isDrawerOpen ? classes.itemCollapsed : ''} ${active ? classes.itemActive : ''}`}
                >
                    <ListItemIcon className={classes.icon}>
                        <Icon style={{color: (isBack || active) ? '#ffffff' : ORANGE, fontSize: '22px'}}/>
                    </ListItemIcon>
                    {isDrawerOpen && <ListItemText className={classes.label} primary={label}/>}
                </ListItem>
                <Divider className={classes.divider}/>
            </>
        );
    };

    return (
        <div style={{display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden'}}>
            <List style={{flexGrow: 1, paddingTop: '8px', overflowY: 'auto'}}>
                <NavItem label="Back to Workspace" icon={ArrowBackIcon} path="/my_workspace" isBack/>

                <NavItem label="Executive Overview" icon={DashboardIcon} path="/dq_pro/class-dashboard/executive-overview"/>
                <NavItem label="Baseline Results" icon={BarChartIcon}      path="/dq_pro/class-dashboard/summary"/>
                <NavItem label="Readiness"        icon={StarIcon}          path="/dq_pro/class-dashboard/readiness"/>
                <NavItem label="Context & Support" icon={AccountBalanceIcon} path="/dq_pro/class-dashboard/context-equity"/>
                <NavItem label="Participation"    icon={PeopleAltIcon}     path="/dq_pro/class-dashboard/participation"/>
                {showLearningDeployment && (
                    <NavItem label="Learning Deployment" icon={MenuBookIcon} path="/dq_pro/class-dashboard/learning-deployment"/>
                )}
            </List>
        </div>
    );
};

export default withRouter(ClassDashboardList);
